<template>
  <div class="mention-logo-loader" role="status" aria-live="polite">
    <div class="mll-mark">
      <img :src="mentionLogo" alt="" class="mll-logo" />
      <span class="mll-shine" :style="{ '--mll-mask': `url(${mentionLogo})` }"></span>
    </div>
    <span v-if="label" class="mll-label">{{ label }}</span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import mentionLogo from '@/assets/images/new/mention-logo.png';

defineProps({
  // User-facing caption shown under the logo (Portuguese, product language).
  label: { type: String, default: '' },
});
</script>

<style scoped>
.mention-logo-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.mll-mark {
  position: relative;
  width: 176px;
  height: 67px;
}

.mll-logo {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/*
 * The sweeping highlight is a separate layer masked with the logo PNG (alpha
 * shape only), so it's clipped to the letter shapes but stacks as a plain
 * semi-transparent overlay on top of the real logo image — preserving the
 * wordmark's two-tone colors (navy body, indigo dot) instead of flattening
 * everything to a single mask color.
 */
.mll-shine {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  -webkit-mask: var(--mll-mask) no-repeat center / contain;
  mask: var(--mll-mask) no-repeat center / contain;
}

.mll-shine::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 55%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.85),
    transparent
  );
  transform: translateX(-80%) skewX(-18deg);
  animation: mll-sweep 2s ease-in-out infinite;
}

@keyframes mll-sweep {
  0% { transform: translateX(-80%) skewX(-18deg); }
  95% { transform: translateX(180%) skewX(-18deg); }
  100% { transform: translateX(180%) skewX(-18deg); }
}

.mll-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #070060;
}

@media (prefers-reduced-motion: reduce) {
  .mll-shine {
    animation-duration: 7s;
  }
}
</style>
